import React, { useState, useEffect, useCallback } from 'react'
import TopHeader from '../../../Component/Header/TopHeader';
import '../../../Pages/Admin/AssitantAdmin/AssistantAdmin.css';
import { Button } from 'react-bootstrap';
// import placeholderImg from '../../../assets/images/placeholder/user_logo.jpg';
import { Link } from 'react-router-dom';
import EditIcon from "@mui/icons-material/Edit";
import { useGetAssistantAdminMutation, useDeleteAssistantAdminMutation } from '../../../app/services/assistantAdmin';
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from 'react-toastify';
import { Box, Typography, Modal, Tooltip, Divider, IconButton } from '@mui/material';
import { useResetPasswordMutation } from '../../../app/services/loginServices';
import KeyIcon from '@mui/icons-material/Key';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { VerifiedUser } from '@material-ui/icons';



const AssistantAdmin = () => {
  const [getAllAssistantAdmin] = useGetAssistantAdminMutation();
  const [deleteAssistantAdmin] = useDeleteAssistantAdminMutation();
  const [adminData, setAdminData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [resetPassword] = useResetPasswordMutation();
  const [deleteId, setDeleteId] = useState();


  const handleOpenModal = (id) => {
    setDeleteId(id)
    setOpenModal(true);
    // setSelectedMember(id);
  };

  const handleClose = (id) => {
    setOpenModal(false);
  };


  const getAlladminDataFn = useCallback(() => {
    const data = {
      role: "PORTAL_ADMIN"
    };

    getAllAssistantAdmin(data)
      .then((res) => {
        if (res?.data?.status) {
          setAdminData(res?.data?.data);
        }
        else {
          setAdminData([])
        }
      })
      .catch((err) => console.log("Error fetching data:", err));
  }, [getAllAssistantAdmin])


  useEffect(() => {
    getAlladminDataFn()
  }, [getAlladminDataFn]);


  const handleDelete = (id) => {
    deleteAssistantAdmin(id).then(res => {
      if (res.data?.status) {
        toast.success('Assistant Admin Deleted Successfully!!!')
        getAlladminDataFn()
        setOpenModal(false);
        getAlladminDataFn();
        handleClose();
      }
      else {
        toast.error('Assistant Admin Delete Failed!!!')
        setOpenModal(false);
      }
    })
  }

  //Reset Password
  const handleResetPassword = (userId) => {
    var data = {
      userId: userId,
      role: "PORTAL_ASSISTANT_ADMIN"
    }
    resetPassword(data).then((res) => {
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      }
      else {
        toast.error(res?.data?.message)
      }
    }).catch(err => console.error(err))
  }


  return (
    <>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Assistant Admin</h2>
        </div>
      </div>
      <div className="p-3 p-md-5 overallPadding">
        <div className="d-flex justify-content-end align-items-center mt-5">
          {adminData?.length < 5 ? (
            <div className="d-flex justify-content-end">
              <Link to={"/admin/AddEditAssistantAdmin"}>
                <Button
                  variant="contained"
                  style={{ marginRight: "35px", color: 'white' }}
                  className="justify-content-end menus-color title-font"
                >
                  ADD ASSISTANT ADMIN
                </Button>
              </Link>
            </div>
          ) : ""}
        </div>

        <div className='cardSection'>
          {adminData && adminData.length > 0 ? (
            <>
              {adminData.map((data, i) => (
                <div key={data._id} className="assistant-admin-card">
                  {/* Actions */}
                  <div className="card-actions">
                    <Tooltip title="Edit">
                      <Link to={`/admin/AddEditAssistantAdmin/${data._id}`}>
                        <IconButton className="action-btn edit-btn" size="small">
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Link>
                    </Tooltip>
                    <Tooltip title="Reset Password">
                      <IconButton onClick={() => handleResetPassword(data.userId)} className="action-btn key-btn" size="small">
                        <KeyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton onClick={() => handleOpenModal(data._id)} className="action-btn delete-btn" size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>

                  {/* Profile Section */}
                  {/* <div className="card-profile">
                    <div className="avatar-container">
                      <img
                        src={data.imageUrl || data.photo_url || placeholderImg}
                        alt={data.name}
                        className="avatar-img"
                        onError={(e) => {
                          e.target.src = placeholderImg;
                        }}
                      />
                    </div>
                    <h3 className="admin-name">{data.name}</h3>
                    <span className="admin-role-badge">Assistant Admin</span>
                  </div> */}
                  <div className="card-details">
                    <div className="detail-item">
                      {/* <span className="detail-label">Name</span> */}
                      <span className="detail-value text-capitalize"><b>{data.name}</b></span>
                    </div>
                  </div>

                  <hr className="card-divider" />

                  {/* Details Section */}
                  <div className="card-details">
                    <div className="detail-item">
                      <span className="detail-label">Email</span>
                      <span className="detail-value">{data.email}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Mobile No</span>
                      <span className="detail-value">{data.phone}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">User ID</span>
                      <span className="detail-value font-monospace"><VerifiedUser className='fs-6 text-success' /> {data.userId}</span>
                    </div>
                  </div>

                  <div className="card-footer-number">
                    <span>#{i + 1}</span>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className='d-flex justify-content-center w-100 grid-full-width'>
              <ErrorOutlineIcon style={{ fontSize: 50, color: 'red' }} />
              <h3 className="text-danger mt-2 ms-2">Will Be Added Shortly</h3>
            </div>
          )}
        </div>
      </div>

      {/* Modal - Put outside the map to avoid duplicates */}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: 500,
            minWidth: 300,
            backgroundColor: "white",
            boxShadow: 24,
            padding: "20px",
            outline: "none",
          }}
          className="d-flex flex-column gap-3 overflow-x-hidden overflow-y-hidden"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
              Confirmation
            </Typography>
            <IconButton onClick={handleClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </div>
          <Box display="flex" justifyContent="center" width="100%">
            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
          </Box>
          <Typography
            id="modal-modal-title"
            style={{ color: "#611f1e" }}
            variant="h6"
            component="h2"
            className="content-font"
          >
            Are You Surely Want to Delete this Assistant Admin?
          </Typography>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              className="content-font"
              style={{
                color: "#dc3545",
                border: "1px solid #dc3545",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={handleClose}
            >
              No
            </Button>
            <Button
              className="mx-2 content-font"
              variant="contained"
              style={{
                backgroundColor: "#2e7d32",
                color: "white",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={() => handleDelete(deleteId)}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default AssistantAdmin;